// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"74":"About","109":"Adventures","268":"Home","315":"Contacts","711":"Publisher"}[chunkId] + "." + {"74":"bdc95029","109":"4c826edf","268":"ac496667","315":"cc4ee9eb","711":"4eca8bf0"}[chunkId] + ".js";
};